import type { AdornisTiptapExtension } from '@adornis/tiptap/client/extensions/ExtensionBase.js';
import { Mark, mergeAttributes } from '@tiptap/core';
import { DigitaleHeldenFont } from '../theme/fonts';

const BoldItalic = Mark.create({
  name: 'boldItalic',

  // Die Standardattribute für die Mark
  addAttributes() {
    return {
      fontFamily: {
        default: DigitaleHeldenFont.BLACK_ITALIC,
      },
    };
  },

  // Die HTML-Darstellung für die Mark
  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        style: `font-family: ${HTMLAttributes.fontFamily}`,
      }),
      0,
    ];
  },
});

export const BoldItalicExtension: AdornisTiptapExtension = {
  buttons: ({ editor }) => {
    const result = [
      {
        name: 'bold-italic',
        icon: 'circle-bolt',
        action: async () => {
          editor.commands.toggleMark('boldItalic');
        },
      },
    ];
    // return result;
    return [];
  },
  extensions: [BoldItalic],
};
